import React from "react";
import "../../css/MenuManagement.css";
import TableDropDownButtonIcon from "../../assets/Icons/TableDropDownButtonIcon.svg";
import TableDropDownOpenButton from "../../assets/Icons/TableDropDownOpenButton.svg";

const MenuCard = ({
  title,
  isActive,
  onToggle,
  options,
  toggleStatus,
  onToggleChange,
  disabled = false,
}) => {
  return (
    <div className="menu-card">
      <div
        className={`menu-card-header ${isActive && "menu-card-header-active"}`}
        onClick={onToggle}
      >
        <button className={`menu-dropdown-btn ${isActive ? "open" : ""}`}>
          <img
            src={isActive ? TableDropDownOpenButton : TableDropDownButtonIcon}
            alt="Dropdown Button"
          />
        </button>
        <h3 className="menu-card-title">{title}</h3>
      </div>
      {isActive && (
        <div className="menu-card-content">
          <ul>
            {options.map((option, index) => (
              <li key={index}>
                {option}
                <button
                  type="button"
                  disabled={disabled}
                  style={{
                    display: "flex",
                    border: "none",
                    background: "none",
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.6 : 1,
                    marginLeft: "10px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!disabled) {
                      onToggleChange(index);
                    }
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "20px",
                      borderRadius: "20px",
                      background: toggleStatus[index] ? "#FF702B" : "#fff",
                      border: "2px solid #FF702B",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: toggleStatus[index]
                        ? "flex-end"
                        : "flex-start",
                      padding: "2px",
                      transition: "background 0.3s, justify-content 0.3s",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#fff",
                        border: toggleStatus[index]
                          ? "none"
                          : "2px solid #FF702B",
                        transition: "background 0.3s, border 0.3s",
                      }}
                    ></div>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MenuCard;
